export const STATUS = {
  AVAILABLE: 'AVAILABLE',
  SOLD: 'SOLD',
  LOCKED: 'LOCKED'
}

export const STATUS_COLORS = {
  [STATUS.AVAILABLE]: 'rgb(85, 117, 78)',
  [STATUS.SOLD]: '#F44336',
  [STATUS.LOCKED]: '#FFD700'
}

export function statusToColor(status, overrides = null) {
  if (overrides && overrides[status]) {
    return overrides[status]
  }
  return STATUS_COLORS[status] || STATUS_COLORS[STATUS.LOCKED]
}


